import { Component, Input, OnInit } from '@angular/core';
import { StateShareCapital } from '../../../../features/application/models/share-capital/share-capital.model';

@Component({
    selector: 'app-share-capital-information-section',
    templateUrl: './share-capital-information-section.component.html',
    styleUrls: ['./share-capital-information-section.component.scss'],
    standalone: false
})
export class ShareCapitalInformationSectionComponent implements OnInit {
  @Input() shareCapital?: StateShareCapital;

  ngOnInit(): void {
  }


  getExchangeRate(cur: string): number | undefined {
    return this.shareCapital?.exchangeRates ? this.shareCapital.exchangeRates.find(er => er.currency === cur)?.value : undefined;
  }

  getExchangeDate(cur: string): string | undefined {
    return this.shareCapital?.exchangeRates ? this.shareCapital.exchangeRates.find(er => er.currency === cur)?.date : undefined;
  }
}